<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>There are many invincible, intelligent women in this world who, like Elizabeth Sterling, have survived terrible adversity with both their</i></span></p>
<p class="ded1"><span><i>dignity and femininity intact</i>.</span></p>
<p class="ded1"><span><i>This work is dedicated to two of them:</i></span></p>
<p class="ded2"><span><i>Patricia Ann Davenport</i>,</span></p>
<p class="ded1"><span><i>my long-time business partner and executive assistant</i>,</span></p>
<p class="ded2"><span><i>and</i></span></p>
<p class="ded2"><span><i>Mary Carolyn Carmichael</i>,</span></p>
<p class="ded1"><span><i>my sister, and a fellow Texas lawyer</i>.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?afdac8ac